import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { YesNoDialogComponent } from 'src/app/shared/dialogs/yes-no-dialog/yes-no-dialog.component';
import { AuthorizationBase } from 'src/app/shared/libraries/authorize-base';
import { ManualInvoiceAutoSendSchedule } from '../models/invoice.model';
import { AlertService } from '../../core/alert.service';
import { CustomerManagementService } from '../../shared/services/customer.service';
import { InvoiceService } from '../services/invoice-service.service';

@Component({
  selector: 'app-invoice-auto-send-schedule',
  templateUrl: './invoice-auto-send-schedule.component.html',
  styleUrls: ['./invoice-auto-send-schedule.component.scss'],
})
export class InvoiceAutoSendScheduleComponent
  extends AuthorizationBase
  implements OnInit
{
  @Input() model: ManualInvoiceAutoSendSchedule;
  @Input() manualInvoiceModel: any;
  @Input() customerModel: any;
  @Input() isView: boolean;

  user: any;
  customerNameLoading: boolean;
  busy: boolean;
  saving: boolean;
  deleting: boolean;
  minDate = new Date();

  constructor(
    private modalRef: NgbActiveModal,
    private alert: AlertService,
    private customerApiService: CustomerManagementService,
    private invoiceService: InvoiceService,
    private modalService: NgbModal
  ) {
    super();

    this.user = this.getCurrentLoginUser();
    this.model = new ManualInvoiceAutoSendSchedule();
    this.minDate.setDate(this.minDate.getDate() + 1);
    this.model.ScheduleDate = this.minDate;
    this.model.ScheduleStatus = 'Pending';
  }

  ngOnInit() {
    if (!this.customerModel) {
      this.loadCustomerInformation();
    }
    console.log(this.model);
  }

  loadDetails() {}

  loadCustomerInformation() {
    this.customerNameLoading = true;
    this.customerApiService
      .getCustomer(this.manualInvoiceModel.customerId)
      .subscribe((res: any) => {
        this.customerModel = res;
        this.customerModel.CustomerName =
          this.customerModel.CustomerTypeId == 1
            ? this.customerModel.FirstName + ' ' + this.customerModel.LastName
            : this.customerModel.BusinessName;
        this.customerNameLoading = false;
      });
  }

  save() {
    this.saving = true;
    this.model.UserId = this.user.UserId;
    this.model.ManualInvoiceId = this.manualInvoiceModel.id;
    this.invoiceService
      .upsertManualInvoiceAutoSendSchedule(this.model)
      .subscribe(
        (res: any) => {
          this.saving = false;
          this.alert.alertSuccess({
            title: 'Success',
            text: 'Invoice successfully updated!',
          });
          this.close(res);
        },
        (error: any) => {
          this.saving = false;
        },
        () => {
          this.saving = false;
        }
      );
  }

  deleteSchedule() {
    let yesNoDialog = this.modalService.open(YesNoDialogComponent, {
      size: 'sm',
    });
    yesNoDialog.componentInstance.content =
      'Are you sure you want to delete this Schedule?';
    yesNoDialog.result.then((res) => {
      if (res) {
        this.deleting = true;
        this.invoiceService
          .deleteScheduledInvoice(this.model.Id, this.user.UserId)
          .subscribe((res: any) => {
            if (res) {
              this.alert.alertSuccess({
                title: 'Success',
                text: 'Invoice successfully deleted!',
              });
              this.deleting = false;
              this.close(true);
            }
          });
      }
    });
  }

  close(data?: any) {
    this.modalRef.close(data);
  }
}
